import { createAction } from '@reduxjs/toolkit'

import type { DashboardPageStoreEntry } from 'redux/reducers/DashboardPage'

// updateOneDashboardPageEntry
export const updateOne = createAction<DashboardPageStoreEntry>(
  'update_dashboard_page'
)

// updateManyDashboardPageEntires
export const updateMany = createAction<DashboardPageStoreEntry[]>(
  'update_dashboard_page_multiple'
)
